import { Component, Input, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { TimeSetupService } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-school-grid",
	templateUrl: "./school-grid.component.html",
	styleUrls: ["./school-grid.component.css"],
})
export class SchoolGridComponent implements OnInit {
	constructor(private timeSetupService: TimeSetupService, private confirmationService: ConfirmationService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		if (this.SchoolID != undefined) {
			this.loadSchoolist();
		}
	}

	ngOnChanges() {
		if (this.SchoolID != undefined) {
			this.loadSchoolist();
		}
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SchoolID: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSchool: any;
	lstSchool: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "SchoolName", header: "School" },
		// { field: 'TardyTime', header: 'Tardy Time' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSchoolist() {
		this.loading = true;

		var result = this.timeSetupService.TimeSettingsSchoolSelectList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				var TodayStr: String = moment(new Date()).format("MM/DD/YYYY");

				for (var i = 0; i < this.lstSchool.length; i++) {
					var next = this.lstSchool[i];

					//Create Date from Tardy Time string
					next.TardyTimeDate = new Date(TodayStr + " " + String(next.TardyTime));
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onUpdate() {
		var fTime = moment(new Date(this.lstSchool[0].TardyTimeDate)).format("hh:mm a");

		var result = this.timeSetupService.TimeSettingsUpdateTardyTime(this.SchoolID, fTime);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "timeschool",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Tardy Time was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "timeschool",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Tardy Time",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onReset() {
		var TodayStr: String = moment(new Date()).format("MM/DD/YYYY");

		//There should only be 1 school for a given school ID
		var next = this.lstSchool[0];

		next.TardyTimeDate = new Date(TodayStr + " " + String(next.TardyTime));
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedSchool = val.data;
	}
	onRowUnselect(val) {
		this.SelectedSchool = null;
	}

	////////////////////////////////////////////
}
